import React, { useEffect } from "react";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";

function HouseKeepingAnalytics2({
  analyticsName,
  analyticsValue,
  bgColor,
  handelFilter,
  selectedCard,
}) {
  const selected = {
    width: 135,
    height: 175,
    marginLeft: "0px",
    transform: "scale(1.1)",
  };
  const notSelected = {
    width: 130,
    height: 160,
  };

  return (
    <Card
      onClick={() => handelFilter(analyticsName[0])}
      sx={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        borderRadius: "16px",

        cursor: "pointer",
        textAlign: "center",
        boxShadow: "none !important",

        transition: "all 0.2s ease-in-out",
        transform:
          selectedCard === analyticsName[0] ? "scale(1.05)" : "scale(1)",
        border:
          selectedCard === analyticsName[0]
            ? "2px solid #3b82f6"
            : "2px solid #dde2eb",
        "&:hover": {
          backgroundColor: "#f1f5f9",
        },
      }}
    >
      <CardContent sx={{ height: "100%" }}>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6">{analyticsValue}</Typography>
          <Typography
            sx={{
              fontSize: "1rem",
              color: "text.secondary",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
              fontWeight: 600,
            }}
          >
            {analyticsName[0] || "ALL ROOMS"}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  // return (
  //   <div>
  //     <Stack direction="row">
  //       <Chip
  //         onClick={() => handelFilter(analyticsName[0])}
  //         style={{ backgroundColor: bgColor, cursor: "pointer" }}
  //         label={
  //           <Stack direction="row" spacing={5}>
  //             <div
  //               style={{
  //                 fontSize: "15px",
  //                 color: "white",
  //                 marginTop: "auto",
  //                 marginBottom: "auto",
  //               }}
  //             >
  //               {analyticsName}
  //             </div>
  //             <div
  //               style={{
  //                 fontSize: "20px",
  //                 color: "white",
  //                 fontWeight: "500",
  //                 marginTop: "auto",
  //                 marginBottom: "auto",
  //               }}
  //             >
  //               {analyticsValue}
  //             </div>
  //           </Stack>
  //         }
  //         //   variant="outlined"
  //       />
  //     </Stack>
  //   </div>
  // );
}

export default HouseKeepingAnalytics2;
